import { AddressInput } from '@dealstack/frontend/investor/pages/Investment/common/personalDetails/AddressInput';
import { PersonalInformationInput } from '@dealstack/frontend/investor/pages/Investment/common/personalDetails/PersonalInformationInput';
import { FormProvider } from 'react-hook-form';

import {
	INVESTMENT_LEAVE_PERSONAL_INFO_FORM,
	useInvestmentLeavePersonalInformationController,
} from './useInvestmentLeavePersonalInformationController';
import { Flex } from '@mantine/core';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
	setIsContinueDisabled: (isContinueDisabled: boolean) => void;
}

export const InvestmentLeavePersonalInformation = ({
	setIsContinueDisabled,
	setIsLoading,
}: Props) => {
	const { personalInformationForm } = useInvestmentLeavePersonalInformationController({
		setIsContinueDisabled,
		setIsLoading,
	});

	return (
		<Flex gap="5rem">
			<FormProvider {...personalInformationForm}>
				<PersonalInformationInput
					firstNameFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.FIRST_NAME}
					lastNameFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.LAST_NAME}
					birthDayFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.BIRTH_DATE}
					phoneNumberFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.PHONE_NUMBER}
					telephonePrefixFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.TELEPHONE_PREFIX}
				/>

				<AddressInput
					postCodeFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.POST_CODE}
					cityFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.CITY}
					countryFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.COUNTRY}
					streetFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.STREET}
					houseNumberFieldName={INVESTMENT_LEAVE_PERSONAL_INFO_FORM.HOUSE_NUMBER}
				/>
			</FormProvider>
		</Flex>
	);
};
